import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiExternalLink, FiStar, FiShield } from 'react-icons/fi';
import './Portfolio.css';

const Portfolio: React.FC = () => {
  const { t } = useTranslation();

  const reviews = [
    // Türkçe yorumlar
    { name: "A. K****", text: "Usta Consulting ile çalışmak büyük bir ayrıcalıktı. E-ticaret satışlarımız %200 arttı!" },
    { name: "M. Y****", text: "Sosyal medya yönetiminde gerçekten uzmanlar. Takipçi sayımız 3 ayda 50.000'e ulaştı." },
    { name: "A. D****", text: "Profesyonel ekip, hızlı iletişim. Usta Consulting'e çok teşekkürler!" },
    { name: "F. Ş****", text: "Marka bilinirliğimiz inanılmaz seviyeye çıktı. Her şey için minnettarız." },
    { name: "E. T****", text: "Dijital pazarlama konusunda en iyi karar Usta Consulting ile çalışmak oldu." },
    { name: "Z. A****", text: "İş ortaklığımızın 2. yılındayız ve hala aynı kaliteyle hizmet alıyoruz." },
    { name: "M. B****", text: "Google reklamlarında ROI'miz %400'e ulaştı. Harika bir ekip!" },
    { name: "E. K****", text: "Web sitemizi baştan aşağı yenilediler. Satışlarımız katlandı!" },
    // Almanca yorumlar
    { name: "T. M****", text: "Ausgezeichnete Zusammenarbeit! Usta Consulting hat unsere Online-Präsenz komplett transformiert." },
    { name: "A. S****", text: "Professionell, zuverlässig und kreativ. Unsere E-Commerce-Umsätze haben sich verdreifacht!" },
    { name: "M. W****", text: "Vielen Dank an das Usta Consulting Team! Die beste Entscheidung für unser Unternehmen." },
    { name: "J. H****", text: "Hervorragende Social-Media-Strategie. Wir sind jetzt Marktführer in unserer Branche." },
    { name: "S. K****", text: "Die Zusammenarbeit war fantastisch. Sehr kompetentes und freundliches Team!" },
    { name: "L. B****", text: "Unsere Markenbekanntheit ist dank Usta Consulting enorm gestiegen. Danke!" },
    { name: "M. F****", text: "Erstklassige Arbeit bei der Website-Entwicklung. Absolut empfehlenswert!" },
    { name: "S. L****", text: "Das Team versteht wirklich digitales Marketing. Unsere Conversion-Rate ist um 300% gestiegen." },
    // İngilizce yorumlar
    { name: "J. R****", text: "Working with Usta Consulting was a game-changer for our business. Highly recommended!" },
    { name: "E. W****", text: "Exceptional service and results. Our online sales increased by 250% in just 6 months!" },
    { name: "D. M****", text: "Thank you Usta Consulting! Your team's expertise in digital marketing is unmatched." },
    { name: "S. T****", text: "Professional, responsive, and incredibly talented. Best decision we ever made." },
    { name: "R. K****", text: "Our social media presence has never been stronger. Amazing work!" },
    { name: "J. L****", text: "The team at Usta Consulting truly understands e-commerce. Our revenue doubled!" },
    { name: "W. H****", text: "Outstanding SEO results. We're now ranking #1 for all our target keywords." },
    { name: "A. P****", text: "Creative, strategic, and results-driven. Usta Consulting delivers excellence!" },
    // Rusça yorumlar
    { name: "А. К****", text: "Usta Consulting - лучшее агентство цифрового маркетинга! Наши продажи выросли на 400%!" },
    { name: "М. С****", text: "Профессиональная команда, отличные результаты. Очень благодарны за сотрудничество!" },
    { name: "Д. В****", text: "Благодаря Usta Consulting мы вышли на международный рынок. Спасибо огромное!" },
    { name: "Е. П****", text: "Превосходная работа по продвижению в социальных сетях. Рекомендую всем!" },
    { name: "А. М****", text: "Наш интернет-магазин теперь получает в 5 раз больше заказов. Потрясающе!" },
    { name: "О. Т****", text: "Креативный подход и профессионализм. Usta Consulting - наши надёжные партнёры." },
    { name: "С. Н****", text: "Отличная SEO-оптимизация. Мы на первой странице Google по всем запросам!" },
    { name: "Н. Б****", text: "Спасибо команде Usta Consulting за великолепную работу! Результаты превзошли ожидания." },
    // Ek Türkçe yorumlar
    { name: "B. S****", text: "Usta Consulting sayesinde Almanya pazarına açıldık. Çok teşekkürler!" },
    { name: "S. M****", text: "İnfluencer kampanyamız viral oldu. 10 milyon görüntülenme aldık!" },
    { name: "O. H****", text: "7/24 destek, profesyonel yaklaşım. Kesinlikle tavsiye ediyorum." }
  ];

  return (
    <section className="portfolio section" id="portfolio">
      <div className="container">
        {/* Crazy Möbel Proje Kartı - Solda logo, sağda bilgi */}
        <motion.div 
          className="featured-project"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="featured-project-logo">
            <img src="/crayzmobel.png" alt="Crazy Möbel Outlet" />
          </div>
          <div className="featured-project-info">
            <span className="featured-project-badge">{t('portfolio.germanyClient')}</span>
            <h3>{t('portfolio.projects.crazymobel.title')}</h3>
            <span className="portfolio-category">{t('portfolio.projects.crazymobel.category')}</span>
            <p>{t('portfolio.projects.crazymobel.desc')}</p>
            <Link to="/portfolio/crazy-mobel" className="featured-project-btn">
              <FiExternalLink />
              {t('portfolio.viewProject')}
            </Link>
          </div>
        </motion.div>

        {/* Müşteri Yorumları */}
        <motion.div 
          className="reviews-section"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="reviews-title">{t('portfolio.reviewsTitle')}</h2>
          <p className="reviews-subtitle">{t('portfolio.reviewsSubtitle')}</p>

          {/* KVKK/GDPR Uyarısı - Yorumların üstünde */}
          <motion.div 
            className="privacy-notice"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <FiShield className="privacy-icon" />
            <p>{t('portfolio.privacyNotice')}</p>
          </motion.div>
          
          <div className="reviews-grid">
            {reviews.map((review, index) => (
              <motion.div 
                key={index}
                className="review-card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3, delay: index * 0.02 }}
              >
                <div className="review-stars">
                  {[...Array(5)].map((_, i) => (
                    <FiStar key={i} className="star-icon" />
                  ))}
                </div>
                <p className="review-text">"{review.text}"</p>
                <div className="review-author">
                  <span className="review-name">{review.name}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Portfolio;
